import { useQuery } from '@tanstack/react-query';
import { getOfficeLocations } from '../../../admin/Services/MasterdataService';
import { masterdataQueryKeys } from '../all-query-keys';

export const useGetOfficeLocations = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: masterdataQueryKeys.officeLocations(),
    queryFn: getOfficeLocations,
  });

  const locations = data?.data?.data || [];

  return {
    locations,
    loading: isLoading,
    refetch,
  };
};
